/**
 * Keep nodes whose name/code matches the query (or have matching descendants).
 */
export const filterTree = (nodes, query) => {
  if (!query) return nodes;
  const lower = query.toLowerCase();

  return nodes.reduce((acc, node) => {
    const nameMatch = node.name?.toLowerCase().includes(lower);
    const codeMatch = node.code?.toLowerCase().includes(lower);
    const filteredChildren = node.children?.length
      ? filterTree(node.children, query)
      : [];

    if (nameMatch || codeMatch || filteredChildren.length > 0) {
      acc.push({ ...node, children: filteredChildren });
    }
    return acc;
  }, []);
};

/**
 * Count all non-group orgs in a tree (recursive).
 */
export const countOrgs = (nodes) => {
  let count = 0;
  for (const node of nodes) {
    if (!node.isGroup) count += 1;
    if (node.children?.length) count += countOrgs(node.children);
  }
  return count;
};
